import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import Modal from '@mui/material/Modal';

import  MoodIcon  from '@mui/icons-material/Mood';

import useIdle from '../hooks/useIdleTimer';
import {useAuth} from "../contexts/AuthContext";
import {Box, Button} from "@mui/material";
import axios from "axios";
import RouteUsageTracker from '../tracking/RouteUsageTracker';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

// ==============================|| NAVIGATION SCROLL TO TOP ||============================== //

const NavigationScroll = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();// we use it for navigation obvs

    const { logout, token, getToken } = useAuth();

    const { pathname } = location;

    const [showModal, setShowModal] = useState(false);

    const [remainingTime, setRemainingTime] = useState(0);

    useEffect(() => {
        async function aquireToken() {
            if (token) {
                axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            } else {
                let tokenResponse = await getToken();
                if (tokenResponse?.accessToken) {
                    axios.defaults.headers.common["Authorization"] = "Bearer " + tokenResponse.accessToken;
                }
            }
        }

        aquireToken();
    },[]);

    const handleIdle = () => {
        setShowModal(true); //show modal
        setRemainingTime(30); //set 15 seconds as time remaining
    };

    const { isIdle } = useIdle({ onIdle: handleIdle, idleTime: 20});

    useEffect(() => {
        let interval;
        if (isIdle && showModal) {
            interval = setInterval(() => {
                setRemainingTime(
                    (prevRemainingTime) =>
                        prevRemainingTime > 0 ? prevRemainingTime - 1 : 0 //reduces the second by 1
                );
            }, 1000);
        }

        return () => {
            clearInterval(interval);
        };
    }, [isIdle, showModal]);

    useEffect(() => {
        if (remainingTime === 0 && showModal) {
            // alert("Time out!");
            //setShowModal(false);
            handleLogOut();
        }
    }, [remainingTime, showModal, navigate]); // this is responsoble for logging user out after timer is down to zero and they have not clicked anything

    const handleLogOut = () => {
        setShowModal(false);
        logout();
    };

    const handleStayLoggedIn = () => {
        setShowModal(false);
    };

    function millisToMinutesAndSeconds(millis) {
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, [pathname]);

    return (
        <>
            <RouteUsageTracker />
            {children || null}
            <Modal
                open={showModal}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style, width: 400 }}>
                    <h2 id="parent-modal-title">.:Cerrando Sesión:.</h2>
                    <p id="parent-modal-description">
                        Tu Sesión va a terminar... ☹️
                    </p>
                    <Button variant={'outlined'} color={'primary'} endIcon={<MoodIcon/>} onClick={handleStayLoggedIn}>Permanecer Aquí</Button>
                </Box>
            </Modal>
        </>
    );
};

NavigationScroll.propTypes = {
    children: PropTypes.node
};

export default NavigationScroll;
